import React from 'react';
import { Form } from '@ant-design/compatible';
import RadioGroup from '../../input/RadioGroup';
import cx from 'classnames';
import './RadioGroupForm.scss';

const RadioGroupForm = (props) => {
  const { className, form, label, rules, name, list, initialValue, onChange, disabled } = props;
  const { getFieldDecorator } = form;

  return (
    <Form.Item className={cx('form-radio-group', 'amondz-form', className)} label={label}>
      {getFieldDecorator(name, {
        rules,
        initialValue,
        // form 만 사용할 경우 onChange 를 넘겨줄 필요 없이 antd 에서 자체적으로 처리함
        onChange: onChange ? (value) => onChange(value) : null,
      })(<RadioGroup list={list} size="large" disabled={disabled} />)}
    </Form.Item>
  );
};

export default RadioGroupForm;
